module.exports = __webpack_public_path__ + "media/images/sp/specials/common/special_c_24-695cdcaf3613b92507d0ab2273c9d293.jpg";